import fetchApi from "../../../../lib/fetchApi";
import { Pagination } from "../../../../types/Pagination";
import { SelectItemDto } from "../../../../types/SelectItemDto";
import { ExtraFieldPaginationFiltersDto, SurveyImportExtraFieldFormDto, SurveyImportExtraFieldListItemDto } from "../types";

const BASE_URL = "/surveyImportExtraFields"

export const getExtraFieldPagination = async (body: ExtraFieldPaginationFiltersDto): Promise<Pagination<SurveyImportExtraFieldListItemDto>> => {
    const response = await fetchApi.post<Pagination<SurveyImportExtraFieldListItemDto>>(`${BASE_URL}/pagination`, body);
    return response;
};

export const getExtraFieldById = async (id: number): Promise<SurveyImportExtraFieldFormDto> => {
    const response = await fetchApi.get<SurveyImportExtraFieldFormDto>(`${BASE_URL}/${id}`);
    return response;
};

export const updateExtraField = async (id: number, body: SurveyImportExtraFieldFormDto): Promise<void> => {
    const response = await fetchApi.put<void>(`${BASE_URL}/${id}`, body);
    return response;
};

export const removeExtraFieldContent = async (id: number): Promise<void> => {
    const response = await fetchApi.put<void>(`${BASE_URL}/remove-content/${id}`, null);
    return response;
};

export const getAllExtraFields = async () : Promise<SurveyImportExtraFieldFormDto[]> => {
    return await fetchApi.get<SurveyImportExtraFieldFormDto[]>(`${BASE_URL}/all`);
}

export const getHistoricalOrderSelectOptions = async () : Promise<SelectItemDto[]> => {
    return await fetchApi.get<SelectItemDto[]>(`${BASE_URL}/historical-orders`);
}